import { getQueryParamsString } from '../../utils/utils';
import { apiGqCustomerClient } from './axios';
import { routes } from './routes';

// Auth
export const bypassAuthPost = (body) => {
    return apiGqCustomerClient({
        method: routes.BYPASS_AUTH.METHOD,
        url: routes.BYPASS_AUTH.URL,
        data: body,
    });
};

// Form Editor / Form Fields
export const customerProfileDetailsUpdateMobilePatch = (body) => {
    return apiGqCustomerClient({
        method: routes.CUSTOMER_PROFILE_DETAILS_UPDATE_MOBILE.METHOD,
        url: routes.CUSTOMER_PROFILE_DETAILS_UPDATE_MOBILE.URL,
        data: body,
    });
};

export const customerMobileAuthNumberPost = (body) => {
    return apiGqCustomerClient({
        method: routes.MOBILE_AUTH_POST_MOBILE.METHOD,
        url: routes.MOBILE_AUTH_POST_MOBILE.URL,
        data: body,
    });
};

export const customerMobileAuthOtpPost = (body) => {
    return apiGqCustomerClient({
        method: routes.MOBILE_AUTH_POST_OTP.METHOD,
        url: routes.MOBILE_AUTH_POST_OTP.URL,
        data: body,
    });
};